/*
 * @Author: mike 13773159347@126.com
 * @Date: 2022-09-19 16:55:34
 * @LastEditors: mike 13773159347@126.com
 * @LastEditTime: 2022-11-22 10:45:50
 * @FilePath: \recruit\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import index from '@/components/index'
import recruitList from '@/views/onlineApp/list'
import recruitDetails from '@/views/onlineApp/details'
import applyInfo from '@/views/onlineApp/applyInfo'
import feedback from '@/views/onlineApp/feedback'
import dormitoryMaintenance from '@/views/onlineApp/dormitoryMaintenance'


Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    // {
    //   path: '/404',
    //   component: (resolve) => require(['@/views/error/404'], resolve),
    //   hidden: true
    // },
    {
      path: '/index',
      name: 'HelloWorld',
      component: index
    },
    {
      path: '/recruitList',
      name: 'recruitList',
      component: recruitList
    },
    {
      path: '/recruitDetails',
      name: 'recruitDetails',
      component: recruitDetails
    },
    {
      path: '/applyInfo',
      name: 'applyInfo',
      component: applyInfo
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback
    },
    {
      path: '/dormitoryMaintenance',
      name: 'dormitoryMaintenance',
      component: dormitoryMaintenance,
      meta:{
        title:"宿舍报修"
      }
    },
    {
      path: '*',
      name: 'notFound',
      meta: {
          iscurrentLocation: true
      },
      component: () => import('../views/error/404.vue')
    }
  ]
})


const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

// const originalPush = Router.prototype.push;
// const originalReplace = Router.prototype.replace;

// Router.prototype.push = function push(location, onResolve, onReject) {
//     if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//     return originalPush.call(this, location).catch(err => err)
// }
// Router.prototype.replace = function push(location, onResolve, onReject) {
//   if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
//   return originalReplace.call(this, location).catch(err => err)
// }



// WEBPACK FOOTER //
// ./src/router/index.js